import type { ShipmentStatus } from '@igoal/shared';
import { Badge, type Tone } from './ui';

const LABEL: Record<ShipmentStatus, string> = { IN_TRANSIT: 'In transit', ARRIVED: 'Arrived', RECEIVED: 'Received', CANCELLED: 'Cancelled' };
const TONE: Record<ShipmentStatus, Tone> = { IN_TRANSIT: 'amber', ARRIVED: 'teal', RECEIVED: 'success', CANCELLED: 'danger' };

export function ShipmentStatusBadge({ status }: { status: ShipmentStatus }) {
  return <Badge tone={TONE[status]} dot>{LABEL[status]}</Badge>;
}

export const shipmentStatusLabel = (s: ShipmentStatus) => LABEL[s];
